import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import './fundsForm.css';
import "../../common/css/component.css";
import "../../common/css/protagonistForm.css";
import { UpdateFund } from '../../common/api/FundAPIHelper';

function FundsForm({ onSubmit, editData, onClear }) {
  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
  const [saveMessage, setSaveMessage] = useState(null);

  // Populate form fields with editData when it changes
  useEffect(() => {
    if (editData) {
      setValue('fundId', editData.fundId);
      setValue('fundName', editData.fundName);
      setValue('targetAssets', editData.targetAssets);
      setValue('currentAssets', editData.currentAssets);
      setValue('fundLPPortal', editData.fundLPPortal);
    } else {
      reset();
    }
  }, [editData, setValue, reset]);

  const handleClear = () => {
    reset(); // Clear form fields
    if (editData) {
      onClear(); // Call the onClear function to clear the editData
    }
  };
    

  const formSubmitHandler = async (data) => {
    try {
      const { fundId, fundName, targetAssets, currentAssets, fundLPPortal } = data;
      const responsePromise = await UpdateFund(fundId, fundName, targetAssets, currentAssets, fundLPPortal);
      const response = await responsePromise;
      
      if (response && response.status === 200) {
        setSaveMessage('Successsfully saved the fund.');
        onSubmit();  // New line
      } else {
        setSaveMessage('There was a problem saving the fund. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setSaveMessage('There was a problem saving the fund. Please try again.');
    }
    reset();
  }

  return (
    <div className="component-container-no-border">
      <form className="prot-admin-form" onSubmit={handleSubmit(formSubmitHandler)}>
        {editData ? (
          <div className="form-edit-message">Editing Fund Id : {editData.fundId}</div>
        ) : (
          <div className="form-edit-message">(Create new Fund)</div>
        )}
        <div className="form-group">
          <label htmlFor="fund-id">Fund Id</label>
          <input type="text" id="fund-id" {...register('fundId', { required: true })} placeholder="Fund Id" onClick={(e) => e.target.select()} />
          {errors.fundId && <span className="error-message">This field is required</span>}
        </div>
        <div className="form-group">
          <label htmlFor="fund-name">Fund Name</label>
          <input type="text" id="fund-name" {...register('fundName', { required: true })} placeholder="Fund Name" onClick={(e) => e.target.select()}/>
          {errors.fundName && <span className="error-message">This field is required</span>}
        </div>
        <div className="form-group">
          <label htmlFor="target-assets">Target Assets Under Management (AUM)</label>
          <input type="text" id="target-assets" {...register('targetAssets', { required: true, pattern: /^[0-9]+(\.[0-9]{1,2})?$/ })} placeholder="$0.00" onClick={(e) => e.target.select()}/>
          {errors.targetAssets?.type === 'required' && <span className="error-message">This field is required</span>}
          {errors.targetAssets?.type === 'pattern' && <span className="error-message">Invalid amount</span>}
        </div>
        <div className="form-group">
          <label htmlFor="current-assets">Current Assets Under Management (AUM)</label>
          <input type="text" id="current-assets" {...register('currentAssets', { required: true, pattern: /^[0-9]+(\.[0-9]{1,2})?$/ })} placeholder="$0.00" onClick={(e) => e.target.select()}/>
          {errors.currentAssets?.type === 'required' && <span className="error-message">This field is required</span>}
          {errors.currentAssets?.type === 'pattern' && <span className="error-message">Invalid amount</span>}
        </div>
        <div className="form-group">
          <label htmlFor="fund-lp-portal">Fund LP Portal</label>
          <input type="url" id="fund-lp-portal" {...register('fundLPPortal', { required: false, pattern: /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/ })} placeholder="LP Portal URL" onClick={(e) => e.target.select()}/>
          {errors.fundLPPortal?.type === 'required' && <span className="error-message">This field is required</span>}
          {errors.fundLPPortal?.type === 'pattern' && <span className="error-message">Invalid URL</span>}
        </div>
        <div className="buttons">
          <button className="ra__protAdminform_button" type="submit">Save</button>
          <button className="ra__protAdminform_button" type="button" onClick={handleClear}>Clear</button>

        </div>
        {saveMessage && <div className="save-message">{saveMessage}</div>}
      </form>
    </div>
  );
}

export default FundsForm;
